import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { api } from '../api/client.js'
import { useApi } from '../api/useApi.js'
import { useAuth } from '../auth.jsx'
import { ClipCard, ClipModal } from '../components/Clips.jsx'
import { ErrorState, Loading } from './states.jsx'

const PAGE = 20

/** Cabinet feed: videos of followed feeders and cats, and of my own meals. */
export default function VideosPage() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const first = useApi(() => api.myClips(), [user.uid])
  const [more, setMore] = useState({ items: [], done: false, busy: false })
  const [openClip, setOpenClip] = useState(null)

  if (first.loading) return <Loading />
  if (first.error) return <ErrorState />
  const items = [...first.data, ...more.items]
  const canLoad = !more.done && first.data.length === PAGE

  const loadMore = async () => {
    setMore((m) => ({ ...m, busy: true }))
    try {
      const page = await api.myClips(items[items.length - 1].id)
      setMore((m) => ({ items: [...m.items, ...page], done: page.length < PAGE, busy: false }))
    } catch {
      setMore((m) => ({ ...m, busy: false }))
    }
  }

  return (
    <main className="mx-auto flex max-w-7xl flex-col gap-7 px-4 pt-10 pb-[72px] sm:px-8">
      <h1 className="text-[clamp(32px,4vw,44px)] font-black tracking-[-1px]">{t('cabinet.videos')}</h1>
      {items.length ? (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(min(280px,100%),1fr))] gap-6">
          {items.map((c) => (
            <ClipCard key={c.id} clip={c} onOpen={(x) => setOpenClip(x.id)} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3 py-16 text-center">
          <span className="text-5xl">🎬</span>
          <span className="text-xl font-extrabold">{t('cabinet.noVideosTitle')}</span>
          <span className="max-w-md text-muted">{t('cabinet.noVideosText')}</span>
          <Link to="/cats" className="rounded-full bg-teal px-6 py-3 font-extrabold text-on-teal no-underline">
            {t('cabinet.findCats')}
          </Link>
        </div>
      )}
      {canLoad && items.length ? (
        <button
          type="button"
          onClick={loadMore}
          disabled={more.busy}
          className="cursor-pointer self-center rounded-full border-[1.5px] border-edge px-6 py-3 font-extrabold hover:border-ink disabled:opacity-60"
        >
          {t('cabinet.loadMore')}
        </button>
      ) : null}
      {openClip ? <ClipModal clipId={openClip} onClose={() => setOpenClip(null)} /> : null}
    </main>
  )
}
